import { gql, useQuery } from 'urql';
import { GetSubmissionByTicketIdResponse } from '../model/types';

export const GET_SUBMISSION_BY_TICKET_ID_QUERY = gql`
  query GetSubmissionByTicketId($ticketId: Int!) {
    getSubmissionByTicketId(ticketId: $ticketId) {
      mainGuest {
        ticketId
        participantId
        firstName
        lastName
        surname
        age
        phone
        email
        ticketType
        scanType
        checkInTime
        organizerName
        additionalFields {
          key
          value
        }
      }
      adultGuests {
        ticketId
        participantId
        firstName
        lastName
        surname
        age
        phone
        email
        ticketType
        scanType
        checkInTime
        organizerName
        additionalFields {
          key
          value
        }
      }
      childrenGuests {
        ticketId
        participantId
        firstName
        lastName
        surname
        age
        phone
        email
        ticketType
        scanType
        checkInTime
        organizerName
        additionalFields {
          key
          value
        }
      }
      radiobuttons {
        titleRadiobutton
        valueRadiobutton
      }
      checkboxes {
        titleCheckboxes
        valueCheckboxes
      }
    }
  }
`;

export const useGetSubmissionByTicketId = (ticketId: number, pause: boolean = false) => {
  const [{ data, error, fetching }, reexecuteQuery] = useQuery<GetSubmissionByTicketIdResponse>({
    query: GET_SUBMISSION_BY_TICKET_ID_QUERY,
    variables: { ticketId },
    pause: !ticketId || pause,
    requestPolicy: 'network-only',
  });

  return {
    data: data?.getSubmissionByTicketId,
    error,
    fetching,
    refetch: reexecuteQuery,
  };
};
